// extracted by mini-css-extract-plugin
module.exports = {"title":"Faq_title__1Hmdj","questionList":"Faq_questionList__ON7kH","noPadding":"Faq_noPadding__2fd8s","paragraph":"Faq_paragraph__3zWCB","wrapper":"Faq_wrapper__N1p3y"};